// import React from "react";
// import { AdvanceTablesWidget7, ListsWidget10, ListsWidget14 } from '../../../_themeBase/_partials/widgets';
// import { toAbsoluteUrl } from "../../../_themeBase/_helpers";

/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, shallowEqual, connect, useDispatch } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { ModalProgressBar } from "../../../_themeBase/_partials/controls";
import * as auth from "../Auth";
import * as actions from "../../../app/actions/generalActions";
import * as columnFormatters from "../../../_themeBase/layout/components/basePage/pages/objects-table/column-formatters";

// export function ProfileOverview() {
//   return (
//     <div className="d-flex flex-row">
//       <div className="col-lg-6">
//         <ListsWidget14 className="card-stretch gutter-b"></ListsWidget14>
//       </div>
//       <div className="col-lg-6">
//         <ListsWidget10 className="card-stretch gutter-b"></ListsWidget10>
//       </div>
//       <div className="col-lg-12">
//         {/* <AdvanceTablesWidget7 className="card-stretch gutter-b"></AdvanceTablesWidget7> */}
//       </div>
//     </div>
//   );
// }




function ProfileOverview(props) {
  // Fields
  const { intl } = props;
  const [loading, setloading] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user, shallowEqual);
  const menu = useSelector((state) => state.auth.menu, shallowEqual);
  const rankingSettings = useSelector((state) => state.baseInfo.rankingSettings, shallowEqual);
  useEffect(() => { }, [user]);
  // Methods
  const history = useHistory()

  function handleConfirmNext() {
    var temp = { ...user }
    temp.registerStatus = 1
    let tempCp = temp
    temp = {}
    temp = {"dto":tempCp,"isCheckProfileImageExistance":false}
    // temp.isActive = 0
    // temp.reasonDeactivated = "اطلاعات و مدارک شما در حال بررسی است"

    setloading(true)

    dispatch(actions.updateObject("api/User", "users", temp, "UpdateUserByMe",true)).then(() => {
      setloading(false);
      history.push("/logout");
      // sessionStorage.setItem(
      //   "userDetail",
      //   JSON.stringify(temp)
      // );
      // stepperUIProps.setUserDetail(temp)
    });

    // updateObject("api/User", temp, "UpdateUserByMe")
    //   .then((response) => {
    //     setloading(false)
    //     // const object = response.data.data;
    //     //dispatch(actions.updateObjectLocal(currentState.name, object))
    //     // ShowToast(
    //     //   "درخواست تایید اطلاعات و مدارک شما ثبت شد. پس از بررسی توسط سرپرست به شما اطلاع رسانی خواهد شد ",
    //     //   ToastType.success,
    //     //   90000
    //     // )
    //     history.push("/logout");
    //   })
    //   .catch((error) => {
    //     setloading(false)
    //     ShowToast(
    //       error,
    //       ToastType.error
    //     );
    //   });

  }

  return (
    <div className="card card-custom">
      {loading && <ModalProgressBar />}

      {/* begin::Header */}
      <div className="card-header py-3">
        <div className="card-title align-items-start flex-column">
          <h3 className="card-label font-weight-bolder text-dark">
            ویرایش اطلاعات و مدارک
          </h3>
          <h3 className="card-label font-weight-bolder text-warning mt-5">
            در صورتی که تمایل به ویرایش اطلاعات و مدارک خود دارید دکمه ویرایش اطلاعات و مدارک را کلیک نمایید
          </h3>
          <span className="card-label font-weight-bolder text-info mt-5">
            پس از کلیک دکمه ویرایش جهت ویرایش اطلاعات و مدارک از سامانه خارج شده و در ورود مجدد به فرم های ویرایش اطلاعات هدایت میشوید
          </span>
          <span className="card-label font-weight-bolder text-danger mt-5">
            لطفا توجه فرمایید در صورت کلیک دکمه ویرایش از سامانه خارج شده و تا زمان تکمیل مدارک امکان ورود به سامانه را ندارید
          </span>
        </div>
      </div>
      {/* end::Header */}
      <div className="card-footer">
        <button
          type="button"
          className="btn btn-primary mr-2"
          onClick={handleConfirmNext}
        >
          ویرایش اطلاعات و مدارک
        </button>
      </div>
    </div>
  );
}

export default connect(null, auth.actions)(ProfileOverview);

